import { render, staticRenderFns } from "./ConfirmPaymentForeman.vue?vue&type=template&id=5735d5e0"
import script from "./ConfirmPaymentForeman.vue?vue&type=script&lang=js"
export * from "./ConfirmPaymentForeman.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPaymentForeman.vue?vue&type=style&index=0&id=5735d5e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports